import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AppContext from '../../context/AppContext';

import { Input } from '../../components/Form';
import { Button } from '../../components/Button';
import {
	TemplateBoolean,
	TemplateField,
} from '../../components/Attributes/Attributes_old';
import LoadingSkeleton from '../../components/Shell/LoadingSkeleton';

import Wrapper from './WrapperOLD';

import { userCreate, userFetchAccessToken } from '../../api';

import useAsync from '../../hooks/useAsync';
import useSearchParams from '../../hooks/useSearchParams';
import { useApp } from '../../context/AppContextBeta';

const Register = () => {
	const navigate = useNavigate();
	const { token } = useSearchParams();
	const { login, isLoggingIn, error: loginError } = useApp();

	const [formState, setFormState] = useState({
		token,
		email: null,
		firstName: null,
		lastName: null,
	});

	const {
		value: loadedToken,
		loading,
		execute: fetchTokenInfo,
	} = useAsync(userFetchAccessToken, {
		immediate: false,
	});

	useEffect(() => {
		if (token) {
			fetchTokenInfo({ accessCode: token });
		} else {
			navigate('/login');
			//return null;
		}
	}, [token]);

	useEffect(() => {
		if (loadedToken) {
			setFormState(loadedToken);
		}
	}, [loadedToken]);

	const { organization: tokenOrganization } = loadedToken || {};

	let tokenOwnerFirstName, tokenOwnerLastName, tokenOwnerEmail;

	if (loadedToken?.createdBy?.firstName) {
		tokenOwnerFirstName = loadedToken.createdBy.firstName || 'a team member';
		tokenOwnerLastName = loadedToken.createdBy.lastName || '';
		tokenOwnerEmail = loadedToken.createdBy.email || '';
	}

	const {
		execute: onSubmit,
		error,
		status,
	} = useAsync(userCreate, {
		immediate: false,
	});

	const forwardMessage = error
		? {
				value:
					'Something went wrong.  Please try again or contact your account manager',
				type: 'error',
			}
		: {
				value: `We found your invitation${
					tokenOrganization?.name ? ` to ${tokenOrganization.name}` : ''
				} ${
					tokenOwnerFirstName
						? `from ${tokenOwnerFirstName} ${tokenOwnerLastName} ${
								tokenOwnerEmail ? `(${tokenOwnerEmail})` : ''
							}`
						: ``
				}`,
				type: 'success',
			};

	const isValid =
		!!formState?.password &&
		!!formState?.confirmPassword &&
		!!formState?.termsChecked &&
		!!formState?.firstName &&
		!!formState?.lastName &&
		!!(formState?.password === formState?.confirmPassword);

	if (loading === 'pending') {
		return <LoadingSkeleton />;
	}

	return (
		<Wrapper title="Complete your registration" message={forwardMessage}>
			<div className="space-y-6">
				<div>
					<label
						htmlFor="email"
						className="block text-sm font-medium text-gray-700"
					>
						Email
					</label>
					<div className="mt-1">
						<Input
							disabled
							placeholder="Enter access code"
							onChange={(e) =>
								setFormState({ ...formState, email: e.target.value })
							}
							value={formState.email}
						/>
					</div>
				</div>
				<div>
					<label
						htmlFor="email"
						className="block text-sm font-medium text-gray-700"
					>
						Name
					</label>
					<div className="flex space-x-2">
						<div className="mt-1">
							<TemplateField
								placeholder="First Name"
								onChange={(dataIndex, firstName) =>
									setFormState({ ...formState, firstName })
								}
								value={formState?.firstName}
								required
							/>
						</div>
						<div className="mt-1">
							<TemplateField
								placeholder="Last Name"
								onChange={(dataIndex, lastName) =>
									setFormState({ ...formState, lastName })
								}
								value={formState?.lastName}
								required
							/>
						</div>
					</div>
				</div>
				<div>
					<label
						htmlFor="email"
						className="block text-sm font-medium text-gray-700"
					>
						Password
					</label>
					<div className="mt-1">
						<Input
							type="password"
							placeholder="Password"
							onChange={(e) =>
								setFormState({ ...formState, password: e.target.value })
							}
							value={formState.password}
						/>
					</div>
				</div>
				<div>
					<label
						htmlFor="email"
						className="block text-sm font-medium text-gray-700"
					>
						Confirm Password
					</label>
					<div className="mt-1">
						<Input
							type="password"
							placeholder="Confirm password"
							onChange={(e) =>
								setFormState({ ...formState, confirmPassword: e.target.value })
							}
							value={formState.confirmPassword}
						/>
					</div>
				</div>

				<div>
					<TemplateBoolean
						description={
							<>
								I agree with Scipods{' '}
								<span className="text-indigo-600 cursor-pointer">
									Terms of Service
								</span>{' '}
								and{' '}
								<span className="text-indigo-600 cursor-pointer">
									Privacy Policy
								</span>
							</>
						}
						onChange={(dataIndex, termsChecked) =>
							setFormState({ ...formState, termsChecked })
						}
						value={formState?.termsChecked}
					/>
				</div>

				<div>
					<Button
						disabled={!isValid}
						type="primary"
						className="flex w-full justify-center"
						onClick={() =>
							onSubmit(formState, () =>
								login({
									email: formState.email,
									password: formState.password,
								}),
							)
						}
					>
						{status === 'pending' || isLoggingIn
							? 'Creating...'
							: 'Create account'}
					</Button>
				</div>
			</div>
		</Wrapper>
	);
};

export default Register;
